import { render, staticRenderFns } from "./AppDownloadToType.vue?vue&type=template&id=6519270a&"
import script from "./AppDownloadToType.vue?vue&type=script&lang=js&"
export * from "./AppDownloadToType.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadToType.vue?vue&type=style&index=0&id=6519270a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports